import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import {
    browserInfo
} from '@/utils/tool';
import {
    Toast
} from 'vant';
Vue.use(Toast);

Vue.use(Router);

// 自动导入module下所有模块
const routes = (modulesFiles => {
    console.log('sdxcf',modulesFiles)
    return modulesFiles.keys().reduce((modules, modulePath) => {
        const value = modulesFiles(modulePath);
        modules.push(...value.default);
        return modules;
    }, []);
})(require.context('./module', false, /\.js$/));

const router = new Router({
    routes,
    mode: 'history',
    base: process.env.VUE_APP_ROUTER_PATH,
    scrollBehavior: () => ({
        y: 0
    })
});

// 跳转白名单
const routerWhiteList = ['/login', '/login-account'];
const defaultTitle = '人文素养课程平台';
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : defaultTitle
    next()
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', to.fullPath]);
        }
    }

    //如果跳转得是登录页，需要记录是从哪个页面跳转的，方便登录后回跳
    let flag = to.name === 'login-account' || to.name === 'login';
    let arr = [
        '/login',
        '/login-account',
        '/bind-phone',
        '/change-phone',
        '/reset-password',
        '/perfect-info',
        '/set-password',
        '/email-enter-code',
        '/enter-password',
        '/login-account-relation',
        '/',
        '/login-relation'
    ];
    if (flag && !arr.includes(from.path)) {
        if (from.name == 'spellGroupDetail' || from.path == '/activity-bargaining') {
            let invitePath = '';
            if (from.query.invite_code) {
                invitePath = from.path + '?team_no=' + from.query.team_no + '&invite_code=' + from.query.invite_code;
            } else {
                invitePath = from.path + '?team_no=' + from.query.team_no;
            }
            store.commit('SET_LOGIN_REDIRECT_URL', invitePath);

        } else {
            store.commit('SET_LOGIN_REDIRECT_URL', from.fullPath);
        }
    }
    let onlinePromotionArr = ['online-apply', 'online-promotion', 'online-poster', 'online-reward', 'online-apply', 'online-collect', 'make-haibao', 'default'];

    if (onlinePromotionArr.includes(to.name)) {
        store.commit('SET_ACTIVITY', true);
    } else {
        store.commit('SET_ACTIVITY', false);
    }

    jumpLogic(to, from, next);
});
//
//跳转逻辑
const jumpLogic = (to, from, next) => {
    console.log('DEBUG_LOG:jumpLogic to', to);
    const token = !!store.getters.token;
    const {
        isLogin,
        userInfo
    } = store.getters;

    if (isLogin) {
        if (routerWhiteList.includes(to.path)) {
            next({
                name: 'index'
            });
        } else {
            //已登录并且本地没有账户信息，需要拉取用户信息
            if (isLogin && (!userInfo || !studentInfo)) {
                store
                    .dispatch('getUserInfo')
                    .then(() => {
                        next();
                    })
                    .catch(() => {
                        next();
                    });
            } else {
                next();
            }
        }
    } else {
        if (to.meta.auth) {
            next({
                name: 'passport'
            });
        } else {
            next();
        }
    }
};

router.afterEach(() => {});

//push
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err);
};

//replace
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
    return VueRouterReplace.call(this, to).catch(err => err);
};

export default router;
